import PageHeader from "@/components/PageHeader";
import RecordsSection from "@/components/RecordsSection";
import { einsatzColumns, einsatzFields, einsatzDefault } from "@/lib/entities";
import { Radio } from "lucide-react";

export default function Einsaetze() {
  return (
    <div>
      <PageHeader
        eyebrow="SADCR · Operationen"
        title="Einsätze"
        description="Dokumentation aller Einsätze, Gespräche und Besuche."
        icon={Radio}
      />
      <div className="p-8">
        <RecordsSection
          endpoint="/einsaetze"
          columns={einsatzColumns}
          fields={einsatzFields}
          makeDefault={einsatzDefault()}
          createLabel="Einsatz dokumentieren"
          emptyLabel="Keine Einsätze erfasst"
          testidPrefix="einsatz"
        />
      </div>
    </div>
  );
}
